import { AppSubscriptionOrderStatus } from "@/services/api/appSubscriptionOrder.type";

const AppSubscriptionOrderStatusNameMap = {
    [AppSubscriptionOrderStatus.CANCELED]: "已取消",
    [AppSubscriptionOrderStatus.PAID]: "已支付",
    [AppSubscriptionOrderStatus.REFUND]: "已退款",
    [AppSubscriptionOrderStatus.UNPAID]: "未支付",
};

export default AppSubscriptionOrderStatusNameMap;
